// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--YjlpZ","text":"_9e1425b4d3--text--AFQ0P","modal-wrapper":"_9e1425b4d3--modal-wrapper--artht"};